<template>
  <div class="postList" data-automationId="postList">
    <PostItem v-for="post in posts" :key="post.id" :post="post" @clicked="selectPost" />
  </div>
</template>

<script>
import PostItem from './PostItem.vue';

export default {
  components: {
    PostItem
  },
  props: ['posts'],
  methods: {
    selectPost(postId) {
      this.$router.push({ name: 'Post',
        params: { id: postId } });
    }
  }
}
</script>

<style scoped>
.postList {
  width: 100%;
}
/* Your CSS here */
</style>